import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';
import { colorPalette } from '@repo/mui-config/color-palette';
export function Breadcrumbs(_a) {
    var onClick = _a.onClick;
    var t = useTranslation().t;
    return (_jsxs(Link, { component: "button", "data-testid": "breadcrumb-button", onClick: onClick, sx: {
            display: 'flex',
            color: colorPalette.pale.light,
            flexDirection: 'row',
            alignItems: 'center',
            gap: 0.5,
        }, underline: "none", children: [_jsx(ArrowBackIcon, {}), _jsx(Typography, { children: t('components.breadcrumb.back') })] }));
}
